import React, { Component } from "react";  
//import Gallery from 'react-grid-gallery';
 
import Slider from 'react-slick';
import Lightbox from 'react-image-lightbox';

class CompContact extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      ourcontactinfo: '',
      logged_auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
    };  
  }  

   componentDidMount() {

      let phone = this.props.phone;
      let email = this.props.email;
      console.log("phonbe",phone);
      this.setState({phone:phone,email:email});
   }



  render() {  

    const { images, current } = this.state;
    
    return <div id="contactinfo_section"><h3>Contact Info</h3>
              { this.state.logged_auth && (
              <div class="contact_info">
               <p>Phone: <strong> {this.state.phone} </strong></p>
               <p>Email: <strong> {this.state.email} </strong></p>
              </div>
              )}
              { !this.state.logged_auth && (
                <div class="contact_info smallwarning">
                Please signin or signup to see this information
                </div>
              )}
          </div>
  }  
}  
   
export default CompContact;